<div class="vertical-nav">
  @for (item of menuItems; track item) {
    @if (
      !item.productArea ||
      featureFlagService.getFeatureAreaVisibility(item.productArea) !== 'hidden'
    ) {
      <a
        class="vertical-nav__link"
        data-cy="vertical-nav-link"
        [routerLink]="item.link || null"
        [matMenuTriggerFor]="item.children ? menu : null"
        [ngClass]="{
          disabled:
            item.productArea &&
            featureFlagService.getFeatureAreaVisibility(item.productArea) ===
              'disabled',
        }"
      >
        @if (item.icon) {
          <mat-icon
            aria-hidden="false"
            [aria-label]="item.label"
            [fontIcon]="item.icon"
          ></mat-icon>
        }
        <span>{{ item.label }}</span>
      </a>
    }
    <mat-menu
      data-cy="vertical-nav-menu"
      #menu="matMenu"
      class="vertical-nav__menu"
    >
      @for (child of item.children; track child) {
        @if (
          !child.feature ||
          featureFlagService.getFeatureVisibility(child.feature) !== 'hidden'
        ) {
          <button
            mat-menu-item
            data-cy="vertical-nav-menu-item"
            [routerLink]="child.link"
            (click)="child.modalKey ? displayModal(child.modalKey) : $event"
            [disabled]="
              featureFlagService.getFeatureVisibility(child.feature) ===
              'disabled'
            "
          >
            <a>{{ child.label }}</a>
          </button>
        }
      }
    </mat-menu>
  }
</div>
